import { useState } from "react";
import { es } from "date-fns/locale";
import { format } from "date-fns";
import { Calendar as CalendarIcon, ChevronDown } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toISO = (d) => format(d, "yyyy-MM-dd");
const fromISO = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);

export function DatePicker({ value, onChange, availableDates, month, onMonthChange, disabled, loading, className }) {
  const [open, setOpen] = useState(false);
  const available = new Set(availableDates);
  const availableDays = availableDates.map(fromISO);

  const select = (d) => {
    if (!d) return;
    onChange(toISO(d));
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid="input-fecha"
          className={`${className} flex items-center justify-between text-left disabled:opacity-50`}>
          <span style={{ color: value ? "var(--text-dark)" : "var(--text-muted)" }}>
            {value ? format(fromISO(value), "EEEE d 'de' MMMM yyyy", { locale: es }) : "Elige una fecha disponible"}
          </span>
          <ChevronDown size={16} style={{ color: "var(--text-muted)" }} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto rounded-2xl p-2" data-testid="date-picker-popover">
        <Calendar
          mode="single"
          locale={es}
          selected={fromISO(value)}
          onSelect={select}
          month={month}
          onMonthChange={onMonthChange}
          fromDate={new Date()}
          disabled={(d) => !available.has(toISO(d))}
          modifiers={{ available: availableDays }}
          modifiersClassNames={{ available: "day-available" }}
          classNames={{ day_selected: "day-selected", day_today: "day-today" }}
        />
        <div className="flex items-center gap-4 px-3 pb-2 pt-1 text-xs" style={{ color: "var(--text-muted)" }} data-testid="date-picker-legend">
          <span className="inline-flex items-center gap-1.5"><span className="h-3 w-3 rounded-full" style={{ background: "var(--mint-light)", border: "1px solid var(--mint)" }} /> Disponible</span>
          <span className="inline-flex items-center gap-1.5"><span className="h-3 w-3 rounded-full opacity-40" style={{ background: "var(--border)" }} /> No disponible</span>
          {loading && <span className="ml-auto">Cargando...</span>}
        </div>
        {!loading && availableDates.length === 0 && (
          <p className="px-3 pb-2 text-xs font-semibold" style={{ color: "#92400E" }} data-testid="no-dates-month">
            Sin fechas disponibles este mes. Prueba el siguiente.
          </p>
        )}
      </PopoverContent>
    </Popover>
  );
}

export { CalendarIcon };
